import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const shop = {
  "en": {
    "heroTitle": "Sell Differently.",
    "heroSub": "Moondala isn't just another marketplace. It's a social marketplace where your customers become your promoters, and every sale can spark the next one.",
    "heroNote": "No monthly fees. No listing fees. You only pay when you make money.",
    "openShopFree": "Open Your Shop — Free",
    "haveAccount": "I Have an Account",
    "whySellers": "Why Sellers Choose Moondala",
    "whySellersSub": "We built what we wished existed — a platform that actually helps you grow, not just hosts your products.",
    "feat1": "Social Commerce Built In",
    "feat1Desc": "Your shop lives inside a social feed. Customers like, comment, share, and buy — all without leaving the app.",
    "feat2": "Smart Product Matching",
    "feat2Desc": "Your products appear in users' feeds and mall based on what they actually care about. No paying for ads.",
    "feat3": "Your Own Mall Page",
    "feat3Desc": "Get a custom, branded storefront — not just a product listing buried in search results.",
    "feat4": "Mobile-First, App-Ready",
    "feat4Desc": "Your customers shop from our iOS & Android app. Push notifications, instant checkout, real mobile experience.",
    "feat5": "No Monthly Fees. Ever.",
    "feat5Desc": "No subscription tiers, no hidden costs. We take a small cut when you sell. That's it.",
    "feat6": "5-Minute Setup",
    "feat6Desc": "Register, add products, start selling. No approval queues, no waiting weeks.",
    "vsOthers": "Moondala vs. Others",
    "cmpMonthly": "Monthly Fee",
    "cmpListing": "Listing Fee",
    "cmpFree": "Free",
    "cmpSocial": "Built-in Social Feed",
    "cmpMobile": "Mobile App for Buyers",
    "cmpMatching": "Smart Product Matching",
    "cmpAlgo": "Algorithm-driven",
    "cmpBasic": "Basic",
    "cmpMall": "Custom Mall / Storefront",
    "cmpAudience": "Built-in Audience",
    "stepsTitle": "Start Selling in 3 Steps",
    "step1": "Create Your Shop",
    "step1Desc": "Sign up free. Pick a name, add your info. Done in 2 minutes.",
    "step2": "Add Products",
    "step2Desc": "Upload photos, set prices, write descriptions. Bulk upload if you have many.",
    "step3": "Get Discovered",
    "step3Desc": "Your products show up in the social feed, mall, and search. Customers come to you.",
    "ctaTitle": "Your shop is waiting.",
    "ctaSub": "Free to start. No credit card required. Set up in minutes.",
    "ctaBtn": "Open Your Shop Now",
    "backToOverview": "Back to Overview",
    "login": "Login",
    "signup": "Register",
    "shopLogin": "Shop Login",
    "email": "Email",
    "password": "Password",
    "loggingIn": "Logging in...",
    "createShopAccount": "Create Shop Account",
    "shopEmail": "Shop Email",
    "shopName": "Shop Name",
    "shopNamePlaceholder": "My Awesome Shop",
    "ownerFirstName": "Owner First Name",
    "ownerLastName": "Owner Last Name",
    "dob": "Date of Birth",
    "country": "Country",
    "phone": "Phone Number",
    "creating": "Creating...",
    "createShop": "Create Shop",
    "noAccount": "Don't have a shop account?",
    "applyHere": "Apply here",
    "hasAccount": "Already have an account?",
    "loginHere": "Login here",
    "goToUserApp": "Go to User App",
    "whyDifferent": "Why Moondala is Different",
    "comparison": "vs Traditional Platforms",
    "cta": "Start Selling",
    "feature1": "Social Commerce Feed",
    "feature1Desc": "Your products appear in a social feed that users browse, like, and share.",
    "feature2": "Smart Product Matching",
    "feature2Desc": "Moondala automatically matches your products with interested buyers.",
    "feature3": "Your Own Mall Page",
    "feature3Desc": "Get a dedicated storefront page where customers can browse your full catalog.",
    "feature4": "Mobile App Ready",
    "feature4Desc": "Your shop works seamlessly on Moondala's mobile app.",
    "feature5": "No Monthly Fees",
    "feature5Desc": "Open your shop for free. No monthly subscription, no listing fees.",
    "feature6": "Live in 5 Minutes",
    "feature6Desc": "No approval queue. Sign up, add products, start selling."
  },
  "ar": {
    "heroTitle": "بِع بطريقة مختلفة.",
    "heroSub": "موندالا ليست مجرد سوق إلكتروني آخر. إنها سوق اجتماعي حيث يصبح عملاؤك مروجين لك، وكل عملية بيع يمكن أن تشعل الأخرى.",
    "heroNote": "بدون رسوم شهرية. بدون رسوم إدراج. تدفع فقط عندما تكسب المال.",
    "openShopFree": "افتح متجرك — مجاناً",
    "haveAccount": "لدي حساب",
    "whySellers": "لماذا يختار البائعون موندالا",
    "whySellersSub": "بنينا ما تمنينا وجوده — منصة تساعدك فعلاً على النمو.",
    "feat1": "تجارة اجتماعية مدمجة",
    "feat1Desc": "متجرك يعيش داخل تغذية اجتماعية. العملاء يعجبون ويعلقون ويشاركون ويشترون — كل ذلك بدون مغادرة التطبيق.",
    "feat2": "مطابقة ذكية للمنتجات",
    "feat2Desc": "منتجاتك تظهر في تغذيات المستخدمين والمول بناءً على اهتماماتهم. بدون إعلانات مدفوعة.",
    "feat3": "صفحة متجرك الخاصة",
    "feat3Desc": "احصل على واجهة متجر مخصصة — ليست مجرد قائمة منتجات مدفونة في نتائج البحث.",
    "feat4": "تطبيق جوال أولاً",
    "feat4Desc": "عملاؤك يتسوقون من تطبيقنا. إشعارات فورية، دفع سريع، تجربة جوال حقيقية.",
    "feat5": "بدون رسوم شهرية. أبداً.",
    "feat5Desc": "بدون مستويات اشتراك، بدون تكاليف خفية. نأخذ نسبة صغيرة عندما تبيع فقط.",
    "feat6": "إعداد في 5 دقائق",
    "feat6Desc": "سجّل، أضف منتجات، ابدأ البيع. بدون طابور موافقة.",
    "vsOthers": "موندالا مقابل الآخرين",
    "cmpMonthly": "الرسوم الشهرية",
    "cmpListing": "رسوم الإدراج",
    "cmpFree": "مجاني",
    "cmpSocial": "تغذية اجتماعية مدمجة",
    "cmpMobile": "تطبيق جوال للمشترين",
    "cmpMatching": "مطابقة ذكية للمنتجات",
    "cmpAlgo": "خوارزمية",
    "cmpBasic": "أساسي",
    "cmpMall": "مول / واجهة متجر مخصصة",
    "cmpAudience": "جمهور مدمج",
    "stepsTitle": "ابدأ البيع في 3 خطوات",
    "step1": "أنشئ متجرك",
    "step1Desc": "سجّل مجاناً. اختر اسماً، أضف معلوماتك. خلال دقيقتين.",
    "step2": "أضف المنتجات",
    "step2Desc": "ارفع صوراً، حدد أسعاراً، اكتب أوصافاً. رفع جماعي متاح.",
    "step3": "اكتشف",
    "step3Desc": "منتجاتك تظهر في التغذية الاجتماعية والمول والبحث. العملاء يأتون إليك.",
    "ctaTitle": "متجرك في انتظارك.",
    "ctaSub": "مجاني للبدء. لا بطاقة ائتمان. جاهز في دقائق.",
    "ctaBtn": "افتح متجرك الآن",
    "backToOverview": "العودة للنظرة العامة",
    "login": "تسجيل الدخول",
    "signup": "إنشاء حساب",
    "shopLogin": "دخول المتجر",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "loggingIn": "جارٍ الدخول...",
    "createShopAccount": "إنشاء حساب متجر",
    "shopEmail": "بريد المتجر",
    "shopName": "اسم المتجر",
    "shopNamePlaceholder": "متجري الرائع",
    "ownerFirstName": "الاسم الأول للمالك",
    "ownerLastName": "اسم العائلة للمالك",
    "dob": "تاريخ الميلاد",
    "country": "البلد",
    "phone": "رقم الهاتف",
    "creating": "جارٍ الإنشاء...",
    "createShop": "إنشاء المتجر",
    "noAccount": "ليس لديك حساب متجر؟",
    "applyHere": "قدّم هنا",
    "hasAccount": "لديك حساب بالفعل؟",
    "loginHere": "سجّل الدخول هنا",
    "goToUserApp": "الذهاب لتطبيق المستخدم",
    "whyDifferent": "لماذا موندالا مختلفة",
    "comparison": "مقابل المنصات التقليدية",
    "cta": "ابدأ البيع",
    "feature1": "تغذية التجارة الاجتماعية",
    "feature1Desc": "منتجاتك تظهر في تغذية اجتماعية يتصفحها المستخدمون ويشاركونها.",
    "feature2": "مطابقة ذكية للمنتجات",
    "feature2Desc": "موندالا تطابق منتجاتك تلقائياً مع المشترين المهتمين.",
    "feature3": "صفحة متجرك الخاصة",
    "feature3Desc": "احصل على واجهة متجر مخصصة يمكن للعملاء تصفح كتالوجك الكامل فيها.",
    "feature4": "جاهز للتطبيق",
    "feature4Desc": "متجرك يعمل بسلاسة على تطبيق موندالا.",
    "feature5": "بدون رسوم شهرية",
    "feature5Desc": "افتح متجرك مجاناً. بدون اشتراك شهري، بدون رسوم إدراج.",
    "feature6": "مباشر في 5 دقائق",
    "feature6Desc": "بدون طابور موافقة. سجّل، أضف منتجات، ابدأ البيع."
  },
  "es": {
    "heroTitle": "Vende Diferente.",
    "heroSub": "Moondala no es solo otro marketplace. Es un mercado social donde tus clientes se convierten en tus promotores.",
    "heroNote": "Sin cuotas mensuales. Sin comisiones por publicar. Solo pagas cuando ganas dinero.",
    "openShopFree": "Abre Tu Tienda — Gratis",
    "haveAccount": "Tengo una Cuenta",
    "whySellers": "Por Qué los Vendedores Eligen Moondala",
    "whySellersSub": "Construimos lo que deseábamos que existiera — una plataforma que realmente te ayuda a crecer.",
    "feat1": "Comercio Social Integrado",
    "feat1Desc": "Tu tienda vive dentro de un feed social. Los clientes dan like, comentan, comparten y compran — todo sin salir de la app.",
    "feat2": "Emparejamiento Inteligente",
    "feat2Desc": "Tus productos aparecen en los feeds basados en lo que realmente les interesa. Sin pagar anuncios.",
    "feat3": "Tu Propia Página Mall",
    "feat3Desc": "Obtén un escaparate personalizado — no solo un listado perdido en los resultados de búsqueda.",
    "feat4": "Primero Móvil",
    "feat4Desc": "Tus clientes compran desde nuestra app. Notificaciones push, pago instantáneo, experiencia móvil real.",
    "feat5": "Sin Cuotas Mensuales. Nunca.",
    "feat5Desc": "Sin niveles de suscripción, sin costos ocultos. Tomamos una pequeña comisión cuando vendes.",
    "feat6": "Configuración en 5 Minutos",
    "feat6Desc": "Regístrate, agrega productos, empieza a vender. Sin colas de aprobación.",
    "vsOthers": "Moondala vs. Otros",
    "cmpMonthly": "Cuota Mensual",
    "cmpListing": "Cuota de Publicación",
    "cmpFree": "Gratis",
    "cmpSocial": "Feed Social Integrado",
    "cmpMobile": "App Móvil para Compradores",
    "cmpMatching": "Emparejamiento Inteligente",
    "cmpAlgo": "Algoritmo",
    "cmpBasic": "Básico",
    "cmpMall": "Mall / Escaparate Personalizado",
    "cmpAudience": "Audiencia Integrada",
    "stepsTitle": "Empieza a Vender en 3 Pasos",
    "step1": "Crea Tu Tienda",
    "step1Desc": "Regístrate gratis. Elige un nombre, agrega tu info. Listo en 2 minutos.",
    "step2": "Agrega Productos",
    "step2Desc": "Sube fotos, pon precios, escribe descripciones.",
    "step3": "Sé Descubierto",
    "step3Desc": "Tus productos aparecen en el feed social, mall y búsqueda. Los clientes vienen a ti.",
    "ctaTitle": "Tu tienda te espera.",
    "ctaSub": "Gratis para empezar. Sin tarjeta de crédito. Listo en minutos.",
    "ctaBtn": "Abre Tu Tienda Ahora",
    "backToOverview": "Volver al Resumen",
    "login": "Iniciar Sesión",
    "signup": "Registrarse",
    "shopLogin": "Acceso de Tienda",
    "email": "Email",
    "password": "Contraseña",
    "loggingIn": "Iniciando sesión...",
    "createShopAccount": "Crear Cuenta de Tienda",
    "shopEmail": "Email de Tienda",
    "shopName": "Nombre de Tienda",
    "shopNamePlaceholder": "Mi Tienda Genial",
    "ownerFirstName": "Nombre del Propietario",
    "ownerLastName": "Apellido del Propietario",
    "dob": "Fecha de Nacimiento",
    "country": "País",
    "phone": "Número de Teléfono",
    "creating": "Creando...",
    "createShop": "Crear Tienda",
    "noAccount": "¿No tienes cuenta de tienda?",
    "applyHere": "Solicita aquí",
    "hasAccount": "¿Ya tienes cuenta?",
    "loginHere": "Inicia sesión aquí",
    "goToUserApp": "Ir a la App de Usuario",
    "whyDifferent": "Por qué Moondala es Diferente",
    "comparison": "vs Plataformas Tradicionales",
    "cta": "Empezar a Vender",
    "feature1": "Feed de Comercio Social",
    "feature1Desc": "Tus productos aparecen en un feed social.",
    "feature2": "Emparejamiento Inteligente",
    "feature2Desc": "Moondala empareja automáticamente tus productos con compradores.",
    "feature3": "Tu Página en el Mall",
    "feature3Desc": "Obtén una página dedicada.",
    "feature4": "Listo para Móvil",
    "feature4Desc": "Tu tienda funciona en la app.",
    "feature5": "Sin Cuotas Mensuales",
    "feature5Desc": "Abre tu tienda gratis.",
    "feature6": "En línea en 5 Minutos",
    "feature6Desc": "Sin cola de aprobación."
  },
  "fr": {
    "heroTitle": "Vendez Autrement.",
    "heroSub": "Moondala n'est pas juste un marketplace. C'est un marché social où vos clients deviennent vos promoteurs.",
    "heroNote": "Pas de frais mensuels. Pas de frais de mise en ligne. Vous ne payez que quand vous gagnez.",
    "openShopFree": "Ouvrez Votre Boutique — Gratuit",
    "haveAccount": "J'ai un Compte",
    "whySellers": "Pourquoi les Vendeurs Choisissent Moondala",
    "whySellersSub": "Nous avons construit ce que nous souhaitions voir exister.",
    "feat1": "Commerce Social Intégré",
    "feat1Desc": "Votre boutique vit dans un flux social. Les clients aiment, commentent, partagent et achètent.",
    "feat2": "Correspondance Intelligente",
    "feat2Desc": "Vos produits apparaissent selon les intérêts des utilisateurs. Sans payer de pub.",
    "feat3": "Votre Page Mall",
    "feat3Desc": "Obtenez une vitrine personnalisée — pas juste une fiche produit perdue dans les résultats.",
    "feat4": "Mobile-First",
    "feat4Desc": "Vos clients achètent depuis notre app. Notifications push, paiement instantané.",
    "feat5": "Pas de Frais Mensuels. Jamais.",
    "feat5Desc": "Pas de niveaux d'abonnement, pas de coûts cachés.",
    "feat6": "Configuration en 5 Minutes",
    "feat6Desc": "Inscrivez-vous, ajoutez des produits, commencez à vendre.",
    "vsOthers": "Moondala vs. Les Autres",
    "cmpMonthly": "Frais Mensuels",
    "cmpListing": "Frais de Mise en Ligne",
    "cmpFree": "Gratuit",
    "cmpSocial": "Flux Social Intégré",
    "cmpMobile": "App Mobile pour Acheteurs",
    "cmpMatching": "Correspondance Intelligente",
    "cmpAlgo": "Algorithme",
    "cmpBasic": "Basique",
    "cmpMall": "Mall / Vitrine Personnalisée",
    "cmpAudience": "Audience Intégrée",
    "stepsTitle": "Commencez à Vendre en 3 Étapes",
    "step1": "Créez Votre Boutique",
    "step1Desc": "Inscrivez-vous gratuitement. Choisissez un nom. Prêt en 2 minutes.",
    "step2": "Ajoutez des Produits",
    "step2Desc": "Uploadez des photos, fixez des prix, écrivez des descriptions.",
    "step3": "Soyez Découvert",
    "step3Desc": "Vos produits apparaissent dans le flux social, le mall et la recherche.",
    "ctaTitle": "Votre boutique vous attend.",
    "ctaSub": "Gratuit pour commencer. Pas de carte de crédit. Prêt en minutes.",
    "ctaBtn": "Ouvrez Votre Boutique Maintenant",
    "backToOverview": "Retour à l'Aperçu",
    "login": "Connexion",
    "signup": "S'inscrire",
    "shopLogin": "Connexion Boutique",
    "email": "Email",
    "password": "Mot de passe",
    "loggingIn": "Connexion en cours...",
    "createShopAccount": "Créer un Compte Boutique",
    "shopEmail": "Email de Boutique",
    "shopName": "Nom de Boutique",
    "shopNamePlaceholder": "Ma Super Boutique",
    "ownerFirstName": "Prénom du Propriétaire",
    "ownerLastName": "Nom du Propriétaire",
    "dob": "Date de Naissance",
    "country": "Pays",
    "phone": "Numéro de Téléphone",
    "creating": "Création...",
    "createShop": "Créer la Boutique",
    "noAccount": "Pas de compte boutique ?",
    "applyHere": "Postulez ici",
    "hasAccount": "Vous avez déjà un compte ?",
    "loginHere": "Connectez-vous ici",
    "goToUserApp": "Aller à l'App Utilisateur",
    "whyDifferent": "Pourquoi Moondala est Différent",
    "comparison": "vs Plateformes Traditionnelles",
    "cta": "Commencer à Vendre",
    "feature1": "Flux Commerce Social",
    "feature1Desc": "Vos produits dans un flux social.",
    "feature2": "Correspondance Intelligente",
    "feature2Desc": "Correspondance automatique.",
    "feature3": "Votre Page Mall",
    "feature3Desc": "Page vitrine dédiée.",
    "feature4": "Prêt pour le Mobile",
    "feature4Desc": "Fonctionne sur l'app mobile.",
    "feature5": "Pas de Frais Mensuels",
    "feature5Desc": "Ouvrez gratuitement.",
    "feature6": "En ligne en 5 Minutes",
    "feature6Desc": "Pas de file d'attente."
  },
  "am": {
    "heroTitle": "በተለየ ይሸጡ።",
    "heroSub": "Moondala isn't just another marketplace. It's a social marketplace where your customers become your promoters, and every sale can spark the next one.",
    "heroNote": "ወርሃዊ ክፍያ የለም። የዝርዝር ክፍያ የለም።",
    "openShopFree": "ሱቅ ይክፈቱ — ነፃ",
    "haveAccount": "መለያ አለኝ",
    "whySellers": "Why Sellers Choose Moondala",
    "whySellersSub": "We built what we wished existed — a platform that actually helps you grow, not just hosts your products.",
    "feat1": "Social Commerce Built In",
    "feat1Desc": "Your shop lives inside a social feed. Customers like, comment, share, and buy — all without leaving the app.",
    "feat2": "Smart Product Matching",
    "feat2Desc": "Your products appear in users' feeds and mall based on what they actually care about. No paying for ads.",
    "feat3": "Your Own Mall Page",
    "feat3Desc": "Get a custom, branded storefront — not just a product listing buried in search results.",
    "feat4": "Mobile-First, App-Ready",
    "feat4Desc": "Your customers shop from our iOS & Android app. Push notifications, instant checkout, real mobile experience.",
    "feat5": "No Monthly Fees. Ever.",
    "feat5Desc": "No subscription tiers, no hidden costs. We take a small cut when you sell. That's it.",
    "feat6": "5-Minute Setup",
    "feat6Desc": "Register, add products, start selling. No approval queues, no waiting weeks.",
    "vsOthers": "Moondala vs. Others",
    "cmpMonthly": "Monthly Fee",
    "cmpListing": "Listing Fee",
    "cmpFree": "Free",
    "cmpSocial": "Built-in Social Feed",
    "cmpMobile": "Mobile App for Buyers",
    "cmpMatching": "Smart Product Matching",
    "cmpAlgo": "Algorithm-driven",
    "cmpBasic": "Basic",
    "cmpMall": "Custom Mall / Storefront",
    "cmpAudience": "Built-in Audience",
    "stepsTitle": "በ3 ደረጃ መሸጥ ይጀምሩ",
    "step1": "Create Your Shop",
    "step1Desc": "Sign up free. Pick a name, add your info. Done in 2 minutes.",
    "step2": "Add Products",
    "step2Desc": "Upload photos, set prices, write descriptions. Bulk upload if you have many.",
    "step3": "Get Discovered",
    "step3Desc": "Your products show up in the social feed, mall, and search. Customers come to you.",
    "ctaTitle": "ሱቅዎ እየጠበቀ ነው።",
    "ctaSub": "ነፃ ለመጀመር። ክሬዲት ካርድ አያስፈልግም።",
    "ctaBtn": "አሁን ሱቅ ይክፈቱ",
    "backToOverview": "ወደ አጠቃላይ ተመለስ",
    "login": "ግባ",
    "signup": "ተመዝገብ",
    "shopLogin": "ሱቅ ግባ",
    "email": "ኢሜይል",
    "password": "የይለፍ ቃል",
    "loggingIn": "በመግባት...",
    "createShopAccount": "ሱቅ መለያ ፍጠር",
    "shopEmail": "ሱቅ ኢሜይል",
    "shopName": "ሱቅ ስም",
    "shopNamePlaceholder": "ሱቅ ስም",
    "ownerFirstName": "ባለቤት ስም",
    "ownerLastName": "ባለቤት ያባት ስም",
    "dob": "ልደት ቀን",
    "country": "ሀገር",
    "phone": "ስልክ",
    "creating": "በመፍጠር...",
    "createShop": "ሱቅ ፍጠር",
    "noAccount": "ሱቅ መለያ የለዎትም?",
    "applyHere": "እዚህ ያመልክቱ",
    "hasAccount": "መለያ አለዎት?",
    "loginHere": "እዚህ ይግቡ",
    "goToUserApp": "ወደ ተጠቃሚ መተግበሪያ",
    "whyDifferent": "Why Moondala is Different",
    "comparison": "vs Traditional Platforms",
    "cta": "Start Selling",
    "feature1": "Social Commerce Feed",
    "feature1Desc": "Your products appear in a social feed that users browse, like, and share.",
    "feature2": "Smart Product Matching",
    "feature2Desc": "Moondala automatically matches your products with interested buyers.",
    "feature3": "Your Own Mall Page",
    "feature3Desc": "Get a dedicated storefront page where customers can browse your full catalog.",
    "feature4": "Mobile App Ready",
    "feature4Desc": "Your shop works seamlessly on Moondala's mobile app.",
    "feature5": "No Monthly Fees",
    "feature5Desc": "Open your shop for free. No monthly subscription, no listing fees.",
    "feature6": "Live in 5 Minutes",
    "feature6Desc": "No approval queue. Sign up, add products, start selling."
  },
  "fil": {
    "heroTitle": "Magbenta nang Iba.",
    "heroSub": "Moondala isn't just another marketplace. It's a social marketplace where your customers become your promoters, and every sale can spark the next one.",
    "heroNote": "Walang monthly fees. Walang listing fees.",
    "openShopFree": "Buksan ang Tindahan — Libre",
    "haveAccount": "May Account Ako",
    "whySellers": "Why Sellers Choose Moondala",
    "whySellersSub": "We built what we wished existed — a platform that actually helps you grow, not just hosts your products.",
    "feat1": "Social Commerce Built In",
    "feat1Desc": "Your shop lives inside a social feed. Customers like, comment, share, and buy — all without leaving the app.",
    "feat2": "Smart Product Matching",
    "feat2Desc": "Your products appear in users' feeds and mall based on what they actually care about. No paying for ads.",
    "feat3": "Your Own Mall Page",
    "feat3Desc": "Get a custom, branded storefront — not just a product listing buried in search results.",
    "feat4": "Mobile-First, App-Ready",
    "feat4Desc": "Your customers shop from our iOS & Android app. Push notifications, instant checkout, real mobile experience.",
    "feat5": "No Monthly Fees. Ever.",
    "feat5Desc": "No subscription tiers, no hidden costs. We take a small cut when you sell. That's it.",
    "feat6": "5-Minute Setup",
    "feat6Desc": "Register, add products, start selling. No approval queues, no waiting weeks.",
    "vsOthers": "Moondala vs. Others",
    "cmpMonthly": "Monthly Fee",
    "cmpListing": "Listing Fee",
    "cmpFree": "Free",
    "cmpSocial": "Built-in Social Feed",
    "cmpMobile": "Mobile App for Buyers",
    "cmpMatching": "Smart Product Matching",
    "cmpAlgo": "Algorithm-driven",
    "cmpBasic": "Basic",
    "cmpMall": "Custom Mall / Storefront",
    "cmpAudience": "Built-in Audience",
    "stepsTitle": "Magsimulang Magbenta sa 3 Hakbang",
    "step1": "Create Your Shop",
    "step1Desc": "Sign up free. Pick a name, add your info. Done in 2 minutes.",
    "step2": "Add Products",
    "step2Desc": "Upload photos, set prices, write descriptions. Bulk upload if you have many.",
    "step3": "Get Discovered",
    "step3Desc": "Your products show up in the social feed, mall, and search. Customers come to you.",
    "ctaTitle": "Naghihintay ang tindahan mo.",
    "ctaSub": "Libreng magsimula. Walang credit card.",
    "ctaBtn": "Buksan ang Tindahan Ngayon",
    "backToOverview": "Bumalik sa Overview",
    "login": "Login",
    "signup": "Register",
    "shopLogin": "Shop Login",
    "email": "Email",
    "password": "Password",
    "loggingIn": "Nagla-login...",
    "createShopAccount": "Gumawa ng Shop Account",
    "shopEmail": "Shop Email",
    "shopName": "Pangalan ng Tindahan",
    "shopNamePlaceholder": "Ang Galing na Tindahan Ko",
    "ownerFirstName": "Pangalan ng May-ari",
    "ownerLastName": "Apelyido ng May-ari",
    "dob": "Petsa ng Kapanganakan",
    "country": "Bansa",
    "phone": "Telepono",
    "creating": "Gumagawa...",
    "createShop": "Gumawa ng Tindahan",
    "noAccount": "Walang shop account?",
    "applyHere": "Mag-apply dito",
    "hasAccount": "May account na?",
    "loginHere": "Mag-login dito",
    "goToUserApp": "Pumunta sa User App",
    "whyDifferent": "Why Moondala is Different",
    "comparison": "vs Traditional Platforms",
    "cta": "Start Selling",
    "feature1": "Social Commerce Feed",
    "feature1Desc": "Your products appear in a social feed that users browse, like, and share.",
    "feature2": "Smart Product Matching",
    "feature2Desc": "Moondala automatically matches your products with interested buyers.",
    "feature3": "Your Own Mall Page",
    "feature3Desc": "Get a dedicated storefront page where customers can browse your full catalog.",
    "feature4": "Mobile App Ready",
    "feature4Desc": "Your shop works seamlessly on Moondala's mobile app.",
    "feature5": "No Monthly Fees",
    "feature5Desc": "Open your shop for free. No monthly subscription, no listing fees.",
    "feature6": "Live in 5 Minutes",
    "feature6Desc": "No approval queue. Sign up, add products, start selling."
  },
  "de": {
    "heroTitle": "Anders verkaufen.",
    "heroSub": "Moondala ist nicht nur ein Marktplatz. Es ist ein sozialer Marktplatz, auf dem Kunden zu Promotern werden.",
    "heroNote": "Keine monatlichen Gebühren. Keine Listungsgebühren. Du zahlst nur, wenn du verdienst.",
    "openShopFree": "Shop eröffnen — Kostenlos",
    "haveAccount": "Ich habe ein Konto",
    "whySellers": "Warum Verkäufer Moondala wählen",
    "whySellersSub": "Wir haben gebaut, was wir uns gewünscht haben — eine Plattform, die dir wirklich beim Wachsen hilft.",
    "feat1": "Integrierter Social Commerce",
    "feat1Desc": "Dein Shop lebt in einem sozialen Feed. Kunden liken, kommentieren, teilen und kaufen.",
    "feat2": "Intelligente Produktzuordnung",
    "feat2Desc": "Deine Produkte erscheinen basierend auf echten Interessen. Keine Werbung nötig.",
    "feat3": "Deine eigene Mall-Seite",
    "feat3Desc": "Bekomme einen eigenen Marken-Shop — nicht nur eine versteckte Produktliste.",
    "feat4": "Mobile-First",
    "feat4Desc": "Deine Kunden kaufen über unsere iOS & Android App.",
    "feat5": "Keine monatlichen Gebühren. Nie.",
    "feat5Desc": "Keine Abo-Stufen, keine versteckten Kosten.",
    "feat6": "5-Minuten-Setup",
    "feat6Desc": "Registrieren, Produkte hinzufügen, verkaufen. Ohne Wartezeit.",
    "vsOthers": "Moondala vs. Andere",
    "cmpMonthly": "Monatliche Gebühr",
    "cmpListing": "Listungsgebühr",
    "cmpFree": "Kostenlos",
    "cmpSocial": "Integrierter Social Feed",
    "cmpMobile": "Mobile App für Käufer",
    "cmpMatching": "Intelligente Produktzuordnung",
    "cmpAlgo": "Algorithmus",
    "cmpBasic": "Basis",
    "cmpMall": "Eigener Mall / Shop",
    "cmpAudience": "Integriertes Publikum",
    "stepsTitle": "In 3 Schritten verkaufen",
    "step1": "Erstelle deinen Shop",
    "step1Desc": "Kostenlos registrieren. Name wählen, Infos eingeben. In 2 Minuten fertig.",
    "step2": "Produkte hinzufügen",
    "step2Desc": "Fotos hochladen, Preise setzen, Beschreibungen schreiben.",
    "step3": "Entdeckt werden",
    "step3Desc": "Deine Produkte erscheinen im Social Feed, Mall und der Suche.",
    "ctaTitle": "Dein Shop wartet.",
    "ctaSub": "Kostenlos starten. Keine Kreditkarte. In Minuten fertig.",
    "ctaBtn": "Jetzt Shop eröffnen",
    "backToOverview": "Zurück zur Übersicht",
    "login": "Anmelden",
    "signup": "Registrieren",
    "shopLogin": "Shop-Anmeldung",
    "email": "E-Mail",
    "password": "Passwort",
    "loggingIn": "Anmeldung...",
    "createShopAccount": "Shop-Konto erstellen",
    "shopEmail": "Shop-E-Mail",
    "shopName": "Shopname",
    "shopNamePlaceholder": "Mein toller Shop",
    "ownerFirstName": "Vorname des Inhabers",
    "ownerLastName": "Nachname des Inhabers",
    "dob": "Geburtsdatum",
    "country": "Land",
    "phone": "Telefonnummer",
    "creating": "Erstelle...",
    "createShop": "Shop erstellen",
    "noAccount": "Kein Shop-Konto?",
    "applyHere": "Hier bewerben",
    "hasAccount": "Bereits ein Konto?",
    "loginHere": "Hier anmelden",
    "goToUserApp": "Zur Benutzer-App",
    "whyDifferent": "Warum Moondala anders ist",
    "comparison": "vs Traditionelle Plattformen",
    "cta": "Jetzt Verkaufen",
    "feature1": "Social Commerce Feed",
    "feature1Desc": "Produkte im sozialen Feed.",
    "feature2": "Intelligente Zuordnung",
    "feature2Desc": "Automatische Produktzuordnung.",
    "feature3": "Eigene Mall-Seite",
    "feature3Desc": "Dedizierte Shopseite.",
    "feature4": "Mobil bereit",
    "feature4Desc": "Funktioniert in der App.",
    "feature5": "Keine monatlichen Gebühren",
    "feature5Desc": "Kostenlos eröffnen.",
    "feature6": "In 5 Minuten live",
    "feature6Desc": "Ohne Genehmigung."
  },
  "hi": {
    "heroTitle": "अलग तरीके से बेचें।",
    "heroSub": "Moondala सिर्फ एक मार्केटप्लेस नहीं है। यह एक सोशल मार्केटप्लेस है जहां आपके ग्राहक आपके प्रमोटर बन जाते हैं।",
    "heroNote": "कोई मासिक शुल्क नहीं। कोई लिस्टिंग शुल्क नहीं। आप सिर्फ तभी भुगतान करते हैं जब कमाते हैं।",
    "openShopFree": "दुकान खोलें — मुफ़्त",
    "haveAccount": "मेरा अकाउंट है",
    "whySellers": "विक्रेता Moondala क्यों चुनते हैं",
    "whySellersSub": "हमने वो बनाया जो हम चाहते थे — एक प्लेटफ़ॉर्म जो सच में बढ़ने में मदद करे।",
    "feat1": "सोशल कॉमर्स बिल्ट इन",
    "feat1Desc": "आपकी दुकान सोशल फ़ीड में रहती है। ग्राहक लाइक, कमेंट, शेयर और खरीदते हैं।",
    "feat2": "स्मार्ट प्रोडक्ट मैचिंग",
    "feat2Desc": "प्रोडक्ट्स यूज़र्स की रुचि के आधार पर दिखते हैं। बिना विज्ञापन।",
    "feat3": "अपना मॉल पेज",
    "feat3Desc": "ब्रांडेड स्टोरफ्रंट पाएं — सिर्फ सर्च में दबी लिस्टिंग नहीं।",
    "feat4": "मोबाइल-फ़र्स्ट",
    "feat4Desc": "ग्राहक हमारी iOS और Android ऐप से खरीदते हैं।",
    "feat5": "कोई मासिक शुल्क नहीं। कभी नहीं।",
    "feat5Desc": "कोई सब्सक्रिप्शन, कोई छिपी लागत नहीं।",
    "feat6": "5 मिनट सेटअप",
    "feat6Desc": "रजिस्टर करें, प्रोडक्ट जोड़ें, बेचना शुरू करें।",
    "vsOthers": "Moondala vs. अन्य",
    "cmpMonthly": "मासिक शुल्क",
    "cmpListing": "लिस्टिंग शुल्क",
    "cmpFree": "मुफ़्त",
    "cmpSocial": "बिल्ट-इन सोशल फ़ीड",
    "cmpMobile": "खरीदारों के लिए मोबाइल ऐप",
    "cmpMatching": "स्मार्ट प्रोडक्ट मैचिंग",
    "cmpAlgo": "एल्गोरिदम",
    "cmpBasic": "बेसिक",
    "cmpMall": "कस्टम मॉल / स्टोरफ्रंट",
    "cmpAudience": "बिल्ट-इन ऑडियंस",
    "stepsTitle": "3 स्टेप्स में बेचना शुरू करें",
    "step1": "दुकान बनाएं",
    "step1Desc": "मुफ़्त साइन अप। नाम चुनें, जानकारी डालें। 2 मिनट में तैयार।",
    "step2": "प्रोडक्ट जोड़ें",
    "step2Desc": "फ़ोटो अपलोड करें, कीमत लगाएं, विवरण लिखें।",
    "step3": "खोजे जाएं",
    "step3Desc": "प्रोडक्ट्स सोशल फ़ीड, मॉल और सर्च में दिखते हैं।",
    "ctaTitle": "आपकी दुकान इंतज़ार कर रही है।",
    "ctaSub": "शुरू करना मुफ़्त। कोई क्रेडिट कार्ड नहीं। मिनटों में तैयार।",
    "ctaBtn": "अभी दुकान खोलें",
    "backToOverview": "वापस अवलोकन पर",
    "login": "लॉगिन",
    "signup": "रजिस्टर",
    "shopLogin": "शॉप लॉगिन",
    "email": "ईमेल",
    "password": "पासवर्ड",
    "loggingIn": "लॉग इन हो रहा है...",
    "createShopAccount": "शॉप अकाउंट बनाएं",
    "shopEmail": "शॉप ईमेल",
    "shopName": "दुकान का नाम",
    "shopNamePlaceholder": "मेरी बढ़िया दुकान",
    "ownerFirstName": "मालिक का नाम",
    "ownerLastName": "मालिक का उपनाम",
    "dob": "जन्म तिथि",
    "country": "देश",
    "phone": "फ़ोन नंबर",
    "creating": "बना रहे हैं...",
    "createShop": "दुकान बनाएं",
    "noAccount": "शॉप अकाउंट नहीं है?",
    "applyHere": "यहां आवेदन करें",
    "hasAccount": "पहले से अकाउंट है?",
    "loginHere": "यहां लॉगिन करें",
    "goToUserApp": "यूज़र ऐप पर जाएं",
    "whyDifferent": "Moondala क्यों अलग है",
    "comparison": "बनाम पारंपरिक प्लेटफ़ॉर्म",
    "cta": "बेचना शुरू करें",
    "feature1": "सोशल कॉमर्स फ़ीड",
    "feature1Desc": "सोशल फ़ीड में प्रोडक्ट्स।",
    "feature2": "स्मार्ट मैचिंग",
    "feature2Desc": "ऑटो मैचिंग।",
    "feature3": "मॉल पेज",
    "feature3Desc": "समर्पित शॉप पेज।",
    "feature4": "मोबाइल तैयार",
    "feature4Desc": "ऐप पर काम करता है।",
    "feature5": "कोई मासिक शुल्क नहीं",
    "feature5Desc": "मुफ़्त खोलें।",
    "feature6": "5 मिनट में लाइव",
    "feature6Desc": "कोई अनुमोदन कतार नहीं।"
  },
  "id": {
    "heroTitle": "Jual dengan Cara Berbeda.",
    "heroSub": "Moondala isn't just another marketplace. It's a social marketplace where your customers become your promoters, and every sale can spark the next one.",
    "heroNote": "Tanpa biaya bulanan. Tanpa biaya listing.",
    "openShopFree": "Buka Toko — Gratis",
    "haveAccount": "Saya Punya Akun",
    "whySellers": "Why Sellers Choose Moondala",
    "whySellersSub": "We built what we wished existed — a platform that actually helps you grow, not just hosts your products.",
    "feat1": "Social Commerce Built In",
    "feat1Desc": "Your shop lives inside a social feed. Customers like, comment, share, and buy — all without leaving the app.",
    "feat2": "Smart Product Matching",
    "feat2Desc": "Your products appear in users' feeds and mall based on what they actually care about. No paying for ads.",
    "feat3": "Your Own Mall Page",
    "feat3Desc": "Get a custom, branded storefront — not just a product listing buried in search results.",
    "feat4": "Mobile-First, App-Ready",
    "feat4Desc": "Your customers shop from our iOS & Android app. Push notifications, instant checkout, real mobile experience.",
    "feat5": "No Monthly Fees. Ever.",
    "feat5Desc": "No subscription tiers, no hidden costs. We take a small cut when you sell. That's it.",
    "feat6": "5-Minute Setup",
    "feat6Desc": "Register, add products, start selling. No approval queues, no waiting weeks.",
    "vsOthers": "Moondala vs. Others",
    "cmpMonthly": "Monthly Fee",
    "cmpListing": "Listing Fee",
    "cmpFree": "Free",
    "cmpSocial": "Built-in Social Feed",
    "cmpMobile": "Mobile App for Buyers",
    "cmpMatching": "Smart Product Matching",
    "cmpAlgo": "Algorithm-driven",
    "cmpBasic": "Basic",
    "cmpMall": "Custom Mall / Storefront",
    "cmpAudience": "Built-in Audience",
    "stepsTitle": "Mulai Berjualan dalam 3 Langkah",
    "step1": "Create Your Shop",
    "step1Desc": "Sign up free. Pick a name, add your info. Done in 2 minutes.",
    "step2": "Add Products",
    "step2Desc": "Upload photos, set prices, write descriptions. Bulk upload if you have many.",
    "step3": "Get Discovered",
    "step3Desc": "Your products show up in the social feed, mall, and search. Customers come to you.",
    "ctaTitle": "Toko Anda menunggu.",
    "ctaSub": "Gratis untuk mulai. Tanpa kartu kredit.",
    "ctaBtn": "Buka Toko Sekarang",
    "backToOverview": "Kembali ke Ikhtisar",
    "login": "Masuk",
    "signup": "Daftar",
    "shopLogin": "Login Toko",
    "email": "Email",
    "password": "Kata Sandi",
    "loggingIn": "Masuk...",
    "createShopAccount": "Buat Akun Toko",
    "shopEmail": "Email Toko",
    "shopName": "Nama Toko",
    "shopNamePlaceholder": "Toko Hebat Saya",
    "ownerFirstName": "Nama Depan Pemilik",
    "ownerLastName": "Nama Belakang Pemilik",
    "dob": "Tanggal Lahir",
    "country": "Negara",
    "phone": "Telepon",
    "creating": "Membuat...",
    "createShop": "Buat Toko",
    "noAccount": "Belum punya akun?",
    "applyHere": "Daftar di sini",
    "hasAccount": "Sudah punya akun?",
    "loginHere": "Masuk di sini",
    "goToUserApp": "Ke Aplikasi Pengguna",
    "whyDifferent": "Why Moondala is Different",
    "comparison": "vs Traditional Platforms",
    "cta": "Start Selling",
    "feature1": "Social Commerce Feed",
    "feature1Desc": "Your products appear in a social feed that users browse, like, and share.",
    "feature2": "Smart Product Matching",
    "feature2Desc": "Moondala automatically matches your products with interested buyers.",
    "feature3": "Your Own Mall Page",
    "feature3Desc": "Get a dedicated storefront page where customers can browse your full catalog.",
    "feature4": "Mobile App Ready",
    "feature4Desc": "Your shop works seamlessly on Moondala's mobile app.",
    "feature5": "No Monthly Fees",
    "feature5Desc": "Open your shop for free. No monthly subscription, no listing fees.",
    "feature6": "Live in 5 Minutes",
    "feature6Desc": "No approval queue. Sign up, add products, start selling."
  },
  "it": {
    "heroTitle": "Vendi in Modo Diverso.",
    "heroSub": "Moondala isn't just another marketplace. It's a social marketplace where your customers become your promoters, and every sale can spark the next one.",
    "heroNote": "Nessun costo mensile. Nessun costo di inserzione.",
    "openShopFree": "Apri il Negozio — Gratis",
    "haveAccount": "Ho un Account",
    "whySellers": "Why Sellers Choose Moondala",
    "whySellersSub": "We built what we wished existed — a platform that actually helps you grow, not just hosts your products.",
    "feat1": "Social Commerce Built In",
    "feat1Desc": "Your shop lives inside a social feed. Customers like, comment, share, and buy — all without leaving the app.",
    "feat2": "Smart Product Matching",
    "feat2Desc": "Your products appear in users' feeds and mall based on what they actually care about. No paying for ads.",
    "feat3": "Your Own Mall Page",
    "feat3Desc": "Get a custom, branded storefront — not just a product listing buried in search results.",
    "feat4": "Mobile-First, App-Ready",
    "feat4Desc": "Your customers shop from our iOS & Android app. Push notifications, instant checkout, real mobile experience.",
    "feat5": "No Monthly Fees. Ever.",
    "feat5Desc": "No subscription tiers, no hidden costs. We take a small cut when you sell. That's it.",
    "feat6": "5-Minute Setup",
    "feat6Desc": "Register, add products, start selling. No approval queues, no waiting weeks.",
    "vsOthers": "Moondala vs. Others",
    "cmpMonthly": "Monthly Fee",
    "cmpListing": "Listing Fee",
    "cmpFree": "Free",
    "cmpSocial": "Built-in Social Feed",
    "cmpMobile": "Mobile App for Buyers",
    "cmpMatching": "Smart Product Matching",
    "cmpAlgo": "Algorithm-driven",
    "cmpBasic": "Basic",
    "cmpMall": "Custom Mall / Storefront",
    "cmpAudience": "Built-in Audience",
    "stepsTitle": "Inizia a Vendere in 3 Passi",
    "step1": "Create Your Shop",
    "step1Desc": "Sign up free. Pick a name, add your info. Done in 2 minutes.",
    "step2": "Add Products",
    "step2Desc": "Upload photos, set prices, write descriptions. Bulk upload if you have many.",
    "step3": "Get Discovered",
    "step3Desc": "Your products show up in the social feed, mall, and search. Customers come to you.",
    "ctaTitle": "Il tuo negozio ti aspetta.",
    "ctaSub": "Gratis per iniziare. Senza carta di credito.",
    "ctaBtn": "Apri il Negozio Ora",
    "backToOverview": "Torna alla Panoramica",
    "login": "Accedi",
    "signup": "Registrati",
    "shopLogin": "Accesso Negozio",
    "email": "Email",
    "password": "Password",
    "loggingIn": "Accesso...",
    "createShopAccount": "Crea Account Negozio",
    "shopEmail": "Email Negozio",
    "shopName": "Nome Negozio",
    "shopNamePlaceholder": "Il Mio Negozio",
    "ownerFirstName": "Nome Proprietario",
    "ownerLastName": "Cognome Proprietario",
    "dob": "Data di Nascita",
    "country": "Paese",
    "phone": "Telefono",
    "creating": "Creazione...",
    "createShop": "Crea Negozio",
    "noAccount": "Non hai un account?",
    "applyHere": "Richiedi qui",
    "hasAccount": "Hai già un account?",
    "loginHere": "Accedi qui",
    "goToUserApp": "Vai all'App Utente",
    "whyDifferent": "Why Moondala is Different",
    "comparison": "vs Traditional Platforms",
    "cta": "Start Selling",
    "feature1": "Social Commerce Feed",
    "feature1Desc": "Your products appear in a social feed that users browse, like, and share.",
    "feature2": "Smart Product Matching",
    "feature2Desc": "Moondala automatically matches your products with interested buyers.",
    "feature3": "Your Own Mall Page",
    "feature3Desc": "Get a dedicated storefront page where customers can browse your full catalog.",
    "feature4": "Mobile App Ready",
    "feature4Desc": "Your shop works seamlessly on Moondala's mobile app.",
    "feature5": "No Monthly Fees",
    "feature5Desc": "Open your shop for free. No monthly subscription, no listing fees.",
    "feature6": "Live in 5 Minutes",
    "feature6Desc": "No approval queue. Sign up, add products, start selling."
  },
  "ja": {
    "heroTitle": "違う売り方をしよう。",
    "heroSub": "Moondalaは単なるマーケットプレイスではありません。顧客がプロモーターになるソーシャルマーケットプレイスです。",
    "heroNote": "月額料金なし。掲載料なし。稼いだ時だけ支払い。",
    "openShopFree": "ショップを開く — 無料",
    "haveAccount": "アカウントを持っています",
    "whySellers": "売り手がMoondalaを選ぶ理由",
    "whySellersSub": "本当に成長を助けるプラットフォームを作りました。",
    "feat1": "ソーシャルコマース内蔵",
    "feat1Desc": "ショップはソーシャルフィード内に存在します。",
    "feat2": "スマート商品マッチング",
    "feat2Desc": "ユーザーの関心に基づいて商品が表示されます。",
    "feat3": "専用モールページ",
    "feat3Desc": "ブランド付きストアフロントを取得。",
    "feat4": "モバイルファースト",
    "feat4Desc": "iOS & Androidアプリから購入。",
    "feat5": "月額料金なし",
    "feat5Desc": "サブスク不要、隠れたコストなし。",
    "feat6": "5分でセットアップ",
    "feat6Desc": "登録、商品追加、販売開始。",
    "vsOthers": "Moondala vs. 他社",
    "cmpMonthly": "月額料金",
    "cmpListing": "掲載料",
    "cmpFree": "無料",
    "cmpSocial": "内蔵ソーシャルフィード",
    "cmpMobile": "購入者向けモバイルアプリ",
    "cmpMatching": "スマートマッチング",
    "cmpAlgo": "アルゴリズム",
    "cmpBasic": "ベーシック",
    "cmpMall": "カスタムモール/ストア",
    "cmpAudience": "内蔵オーディエンス",
    "stepsTitle": "3ステップで販売開始",
    "step1": "ショップを作成",
    "step1Desc": "無料登録。名前を選び、情報入力。2分で完了。",
    "step2": "商品を追加",
    "step2Desc": "写真をアップロード、価格設定、説明を書く。",
    "step3": "発見される",
    "step3Desc": "商品がソーシャルフィード、モール、検索に表示。",
    "ctaTitle": "あなたのショップが待っています。",
    "ctaSub": "無料で開始。クレジットカード不要。数分で準備完了。",
    "ctaBtn": "今すぐショップを開く",
    "backToOverview": "概要に戻る",
    "login": "ログイン",
    "signup": "登録",
    "shopLogin": "ショップログイン",
    "email": "メール",
    "password": "パスワード",
    "loggingIn": "ログイン中...",
    "createShopAccount": "ショップアカウント作成",
    "shopEmail": "ショップメール",
    "shopName": "ショップ名",
    "shopNamePlaceholder": "素敵なショップ",
    "ownerFirstName": "オーナー名",
    "ownerLastName": "オーナー姓",
    "dob": "生年月日",
    "country": "国",
    "phone": "電話番号",
    "creating": "作成中...",
    "createShop": "ショップ作成",
    "noAccount": "ショップアカウントがない？",
    "applyHere": "こちらから申請",
    "hasAccount": "アカウントをお持ち？",
    "loginHere": "こちらからログイン",
    "goToUserApp": "ユーザーアプリへ",
    "whyDifferent": "Moondalaが違う理由",
    "comparison": "vs 従来のプラットフォーム",
    "cta": "販売を始める",
    "feature1": "ソーシャルコマースフィード",
    "feature1Desc": "ソーシャルフィードに商品表示。",
    "feature2": "スマートマッチング",
    "feature2Desc": "自動マッチング。",
    "feature3": "モールページ",
    "feature3Desc": "専用ショップページ。",
    "feature4": "モバイル対応",
    "feature4Desc": "アプリで動作。",
    "feature5": "月額料金なし",
    "feature5Desc": "無料で開店。",
    "feature6": "5分でライブ",
    "feature6Desc": "承認待ちなし。"
  },
  "ko": {
    "heroTitle": "다르게 판매하세요.",
    "heroSub": "Moondala는 단순한 마켓이 아닙니다. 고객이 프로모터가 되는 소셜 마켓플레이스입니다.",
    "heroNote": "월 요금 없음. 등록비 없음. 벌 때만 지불.",
    "openShopFree": "가게 열기 — 무료",
    "haveAccount": "계정이 있어요",
    "whySellers": "판매자가 Moondala를 선택하는 이유",
    "whySellersSub": "실제로 성장을 돕는 플랫폼을 만들었습니다.",
    "feat1": "소셜 커머스 내장",
    "feat1Desc": "가게가 소셜 피드에 존재합니다.",
    "feat2": "스마트 제품 매칭",
    "feat2Desc": "관심사 기반으로 제품이 표시됩니다.",
    "feat3": "나만의 몰 페이지",
    "feat3Desc": "브랜드 스토어프론트를 받으세요.",
    "feat4": "모바일 퍼스트",
    "feat4Desc": "iOS & Android 앱에서 쇼핑.",
    "feat5": "월 요금 없음",
    "feat5Desc": "구독 없이, 숨겨진 비용 없이.",
    "feat6": "5분 설정",
    "feat6Desc": "등록, 제품 추가, 판매 시작.",
    "vsOthers": "Moondala vs. 기타",
    "cmpMonthly": "월 요금",
    "cmpListing": "등록비",
    "cmpFree": "무료",
    "cmpSocial": "내장 소셜 피드",
    "cmpMobile": "구매자용 모바일 앱",
    "cmpMatching": "스마트 매칭",
    "cmpAlgo": "알고리즘",
    "cmpBasic": "기본",
    "cmpMall": "커스텀 몰/스토어",
    "cmpAudience": "내장 오디언스",
    "stepsTitle": "3단계로 판매 시작",
    "step1": "가게 만들기",
    "step1Desc": "무료 가입. 이름 선택. 2분 완료.",
    "step2": "제품 추가",
    "step2Desc": "사진 업로드, 가격 설정.",
    "step3": "발견되기",
    "step3Desc": "소셜 피드, 몰, 검색에 제품 표시.",
    "ctaTitle": "가게가 기다리고 있어요.",
    "ctaSub": "무료 시작. 카드 불필요. 몇 분이면 준비.",
    "ctaBtn": "지금 가게 열기",
    "backToOverview": "개요로 돌아가기",
    "login": "로그인",
    "signup": "가입",
    "shopLogin": "가게 로그인",
    "email": "이메일",
    "password": "비밀번호",
    "loggingIn": "로그인 중...",
    "createShopAccount": "가게 계정 만들기",
    "shopEmail": "가게 이메일",
    "shopName": "가게 이름",
    "shopNamePlaceholder": "멋진 가게",
    "ownerFirstName": "소유자 이름",
    "ownerLastName": "소유자 성",
    "dob": "생년월일",
    "country": "국가",
    "phone": "전화번호",
    "creating": "생성 중...",
    "createShop": "가게 만들기",
    "noAccount": "가게 계정이 없나요?",
    "applyHere": "여기서 신청",
    "hasAccount": "이미 계정이 있나요?",
    "loginHere": "여기서 로그인",
    "goToUserApp": "사용자 앱으로",
    "whyDifferent": "Moondala가 다른 이유",
    "comparison": "vs 기존 플랫폼",
    "cta": "판매 시작",
    "feature1": "소셜 커머스 피드",
    "feature1Desc": "소셜 피드에 제품.",
    "feature2": "스마트 매칭",
    "feature2Desc": "자동 매칭.",
    "feature3": "몰 페이지",
    "feature3Desc": "전용 가게 페이지.",
    "feature4": "모바일 준비",
    "feature4Desc": "앱에서 작동.",
    "feature5": "월 요금 없음",
    "feature5Desc": "무료 개점.",
    "feature6": "5분 라이브",
    "feature6Desc": "승인 불필요."
  },
  "zh": {
    "heroTitle": "换种方式销售。",
    "heroSub": "Moondala不只是一个市场。它是一个社交市场，您的客户成为您的推广者。",
    "heroNote": "无月费。无上架费。只在赚钱时付费。",
    "openShopFree": "开店 — 免费",
    "haveAccount": "我有账号",
    "whySellers": "卖家为什么选择Moondala",
    "whySellersSub": "我们打造了真正帮助你成长的平台。",
    "feat1": "内置社交商务",
    "feat1Desc": "店铺存在于社交信息流中。客户点赞、评论、分享和购买。",
    "feat2": "智能产品匹配",
    "feat2Desc": "基于用户兴趣展示产品。无需广告。",
    "feat3": "专属商城页面",
    "feat3Desc": "获得品牌化店铺 — 不只是搜索中的列表。",
    "feat4": "移动优先",
    "feat4Desc": "客户通过iOS和Android应用购物。",
    "feat5": "永远无月费",
    "feat5Desc": "无订阅层级，无隐藏费用。",
    "feat6": "5分钟设置",
    "feat6Desc": "注册、添加产品、开始销售。",
    "vsOthers": "Moondala vs. 其他",
    "cmpMonthly": "月费",
    "cmpListing": "上架费",
    "cmpFree": "免费",
    "cmpSocial": "内置社交信息流",
    "cmpMobile": "买家移动应用",
    "cmpMatching": "智能产品匹配",
    "cmpAlgo": "算法",
    "cmpBasic": "基础",
    "cmpMall": "自定义商城/店铺",
    "cmpAudience": "内置受众",
    "stepsTitle": "3步开始销售",
    "step1": "创建店铺",
    "step1Desc": "免费注册。选择名称。2分钟完成。",
    "step2": "添加产品",
    "step2Desc": "上传照片、设定价格、写描述。",
    "step3": "被发现",
    "step3Desc": "产品出现在社交信息流、商城和搜索中。",
    "ctaTitle": "你的店铺在等你。",
    "ctaSub": "免费开始。无需信用卡。几分钟搞定。",
    "ctaBtn": "立即开店",
    "backToOverview": "返回概览",
    "login": "登录",
    "signup": "注册",
    "shopLogin": "店铺登录",
    "email": "邮箱",
    "password": "密码",
    "loggingIn": "登录中...",
    "createShopAccount": "创建店铺账户",
    "shopEmail": "店铺邮箱",
    "shopName": "店铺名称",
    "shopNamePlaceholder": "我的店铺",
    "ownerFirstName": "店主名",
    "ownerLastName": "店主姓",
    "dob": "出生日期",
    "country": "国家",
    "phone": "电话",
    "creating": "创建中...",
    "createShop": "创建店铺",
    "noAccount": "没有店铺账户？",
    "applyHere": "在此申请",
    "hasAccount": "已有账户？",
    "loginHere": "在此登录",
    "goToUserApp": "前往用户应用",
    "whyDifferent": "Moondala为什么不同",
    "comparison": "对比传统平台",
    "cta": "开始销售",
    "feature1": "社交商务信息流",
    "feature1Desc": "社交信息流中展示产品。",
    "feature2": "智能匹配",
    "feature2Desc": "自动匹配。",
    "feature3": "商城页面",
    "feature3Desc": "专属店铺页面。",
    "feature4": "移动就绪",
    "feature4Desc": "应用中运行。",
    "feature5": "无月费",
    "feature5Desc": "免费开店。",
    "feature6": "5分钟上线",
    "feature6Desc": "无需审批。"
  },
  "pt": {
    "heroTitle": "Venda Diferente.",
    "heroSub": "Moondala não é só mais um marketplace. É um mercado social onde seus clientes se tornam promotores.",
    "heroNote": "Sem taxas mensais. Sem taxas de listagem. Você só paga quando ganha.",
    "openShopFree": "Abra Sua Loja — Grátis",
    "haveAccount": "Tenho uma Conta",
    "whySellers": "Por Que Vendedores Escolhem Moondala",
    "whySellersSub": "Criamos o que gostaríamos que existisse.",
    "feat1": "Comércio Social Integrado",
    "feat1Desc": "Sua loja vive dentro de um feed social.",
    "feat2": "Combinação Inteligente",
    "feat2Desc": "Produtos aparecem baseados em interesses reais.",
    "feat3": "Sua Página Mall",
    "feat3Desc": "Tenha uma vitrine personalizada.",
    "feat4": "Mobile-First",
    "feat4Desc": "Clientes compram pelo app iOS & Android.",
    "feat5": "Sem Taxas Mensais. Nunca.",
    "feat5Desc": "Sem níveis de assinatura, sem custos ocultos.",
    "feat6": "Configuração em 5 Min",
    "feat6Desc": "Cadastre-se, adicione produtos, comece a vender.",
    "vsOthers": "Moondala vs. Outros",
    "cmpMonthly": "Taxa Mensal",
    "cmpListing": "Taxa de Listagem",
    "cmpFree": "Grátis",
    "cmpSocial": "Feed Social Integrado",
    "cmpMobile": "App Mobile para Compradores",
    "cmpMatching": "Combinação Inteligente",
    "cmpAlgo": "Algoritmo",
    "cmpBasic": "Básico",
    "cmpMall": "Mall/Loja Personalizada",
    "cmpAudience": "Audiência Integrada",
    "stepsTitle": "Comece a Vender em 3 Passos",
    "step1": "Crie Sua Loja",
    "step1Desc": "Cadastre-se grátis. Escolha um nome. Pronto em 2 min.",
    "step2": "Adicione Produtos",
    "step2Desc": "Envie fotos, defina preços, escreva descrições.",
    "step3": "Seja Descoberto",
    "step3Desc": "Produtos aparecem no feed social, mall e busca.",
    "ctaTitle": "Sua loja está esperando.",
    "ctaSub": "Grátis para começar. Sem cartão. Pronto em minutos.",
    "ctaBtn": "Abra Sua Loja Agora",
    "backToOverview": "Voltar ao Resumo",
    "login": "Entrar",
    "signup": "Cadastrar",
    "shopLogin": "Login da Loja",
    "email": "Email",
    "password": "Senha",
    "loggingIn": "Entrando...",
    "createShopAccount": "Criar Conta da Loja",
    "shopEmail": "Email da Loja",
    "shopName": "Nome da Loja",
    "shopNamePlaceholder": "Minha Loja Incrível",
    "ownerFirstName": "Nome do Proprietário",
    "ownerLastName": "Sobrenome do Proprietário",
    "dob": "Data de Nascimento",
    "country": "País",
    "phone": "Telefone",
    "creating": "Criando...",
    "createShop": "Criar Loja",
    "noAccount": "Não tem conta?",
    "applyHere": "Solicite aqui",
    "hasAccount": "Já tem conta?",
    "loginHere": "Entre aqui",
    "goToUserApp": "Ir para App de Usuário",
    "whyDifferent": "Por que Moondala é Diferente",
    "comparison": "vs Plataformas Tradicionais",
    "cta": "Começar a Vender",
    "feature1": "Feed Social Commerce",
    "feature1Desc": "Produtos no feed social.",
    "feature2": "Combinação Inteligente",
    "feature2Desc": "Combinação automática.",
    "feature3": "Página Mall",
    "feature3Desc": "Página dedicada.",
    "feature4": "Mobile Pronto",
    "feature4Desc": "Funciona no app.",
    "feature5": "Sem Taxas Mensais",
    "feature5Desc": "Abra grátis.",
    "feature6": "Online em 5 Min",
    "feature6Desc": "Sem aprovação."
  },
  "ru": {
    "heroTitle": "Продавайте по-другому.",
    "heroSub": "Moondala — не просто маркетплейс. Это социальный маркетплейс, где покупатели становятся промоутерами.",
    "heroNote": "Без ежемесячных платежей. Без платы за размещение. Платите только когда зарабатываете.",
    "openShopFree": "Открыть магазин — Бесплатно",
    "haveAccount": "У меня есть аккаунт",
    "whySellers": "Почему продавцы выбирают Moondala",
    "whySellersSub": "Мы создали то, что хотели видеть сами.",
    "feat1": "Встроенная социальная коммерция",
    "feat1Desc": "Магазин живёт в социальной ленте.",
    "feat2": "Умный подбор товаров",
    "feat2Desc": "Товары отображаются на основе интересов.",
    "feat3": "Своя страница в молле",
    "feat3Desc": "Фирменная витрина.",
    "feat4": "Mobile-First",
    "feat4Desc": "Покупатели используют iOS и Android приложение.",
    "feat5": "Без ежемесячных платежей",
    "feat5Desc": "Без подписок, без скрытых затрат.",
    "feat6": "Настройка за 5 минут",
    "feat6Desc": "Регистрация, добавление товаров, начало продаж.",
    "vsOthers": "Moondala vs. Другие",
    "cmpMonthly": "Ежемесячная плата",
    "cmpListing": "Плата за размещение",
    "cmpFree": "Бесплатно",
    "cmpSocial": "Встроенная соцлента",
    "cmpMobile": "Мобильное приложение",
    "cmpMatching": "Умный подбор",
    "cmpAlgo": "Алгоритм",
    "cmpBasic": "Базовый",
    "cmpMall": "Свой молл/магазин",
    "cmpAudience": "Встроенная аудитория",
    "stepsTitle": "Начните продавать за 3 шага",
    "step1": "Создайте магазин",
    "step1Desc": "Бесплатная регистрация. За 2 минуты.",
    "step2": "Добавьте товары",
    "step2Desc": "Загрузите фото, установите цены.",
    "step3": "Будьте найдены",
    "step3Desc": "Товары в социальной ленте, молле и поиске.",
    "ctaTitle": "Ваш магазин ждёт.",
    "ctaSub": "Бесплатный старт. Без карты. За минуты.",
    "ctaBtn": "Открыть магазин сейчас",
    "backToOverview": "Назад к обзору",
    "login": "Войти",
    "signup": "Регистрация",
    "shopLogin": "Вход в магазин",
    "email": "Email",
    "password": "Пароль",
    "loggingIn": "Вход...",
    "createShopAccount": "Создать аккаунт магазина",
    "shopEmail": "Email магазина",
    "shopName": "Название магазина",
    "shopNamePlaceholder": "Мой магазин",
    "ownerFirstName": "Имя владельца",
    "ownerLastName": "Фамилия владельца",
    "dob": "Дата рождения",
    "country": "Страна",
    "phone": "Телефон",
    "creating": "Создание...",
    "createShop": "Создать магазин",
    "noAccount": "Нет аккаунта?",
    "applyHere": "Подать заявку",
    "hasAccount": "Уже есть аккаунт?",
    "loginHere": "Войти здесь",
    "goToUserApp": "К приложению пользователя",
    "whyDifferent": "Почему Moondala отличается",
    "comparison": "vs Традиционные платформы",
    "cta": "Начать продавать",
    "feature1": "Социальная лента",
    "feature1Desc": "Товары в соцленте.",
    "feature2": "Умный подбор",
    "feature2Desc": "Автоподбор.",
    "feature3": "Страница молла",
    "feature3Desc": "Выделенная страница.",
    "feature4": "Мобильная версия",
    "feature4Desc": "Работает в приложении.",
    "feature5": "Без ежемесячных",
    "feature5Desc": "Бесплатное открытие.",
    "feature6": "За 5 минут",
    "feature6Desc": "Без очереди."
  },
  "so": {
    "heroTitle": "Si kala duwan u iibi.",
    "heroSub": "Moondala isn't just another marketplace. It's a social marketplace where your customers become your promoters, and every sale can spark the next one.",
    "heroNote": "Lacag bishii ma jirto. Lacag liiska ma jirto.",
    "openShopFree": "Fur Dukaan — Bilaash",
    "haveAccount": "Akoon baan leeyahay",
    "whySellers": "Why Sellers Choose Moondala",
    "whySellersSub": "We built what we wished existed — a platform that actually helps you grow, not just hosts your products.",
    "feat1": "Social Commerce Built In",
    "feat1Desc": "Your shop lives inside a social feed. Customers like, comment, share, and buy — all without leaving the app.",
    "feat2": "Smart Product Matching",
    "feat2Desc": "Your products appear in users' feeds and mall based on what they actually care about. No paying for ads.",
    "feat3": "Your Own Mall Page",
    "feat3Desc": "Get a custom, branded storefront — not just a product listing buried in search results.",
    "feat4": "Mobile-First, App-Ready",
    "feat4Desc": "Your customers shop from our iOS & Android app. Push notifications, instant checkout, real mobile experience.",
    "feat5": "No Monthly Fees. Ever.",
    "feat5Desc": "No subscription tiers, no hidden costs. We take a small cut when you sell. That's it.",
    "feat6": "5-Minute Setup",
    "feat6Desc": "Register, add products, start selling. No approval queues, no waiting weeks.",
    "vsOthers": "Moondala vs. Others",
    "cmpMonthly": "Monthly Fee",
    "cmpListing": "Listing Fee",
    "cmpFree": "Free",
    "cmpSocial": "Built-in Social Feed",
    "cmpMobile": "Mobile App for Buyers",
    "cmpMatching": "Smart Product Matching",
    "cmpAlgo": "Algorithm-driven",
    "cmpBasic": "Basic",
    "cmpMall": "Custom Mall / Storefront",
    "cmpAudience": "Built-in Audience",
    "stepsTitle": "3 Tallaabo ku bilow Iibinta",
    "step1": "Create Your Shop",
    "step1Desc": "Sign up free. Pick a name, add your info. Done in 2 minutes.",
    "step2": "Add Products",
    "step2Desc": "Upload photos, set prices, write descriptions. Bulk upload if you have many.",
    "step3": "Get Discovered",
    "step3Desc": "Your products show up in the social feed, mall, and search. Customers come to you.",
    "ctaTitle": "Dukkaankaagu wuu sugayaa.",
    "ctaSub": "Bilaash bilow. Kaarka ma loo baahna.",
    "ctaBtn": "Hadda Dukaan Fur",
    "backToOverview": "Ku noqo Guud-mar",
    "login": "Soo gal",
    "signup": "Is diiwaan geli",
    "shopLogin": "Soo gal Dukaan",
    "email": "Iimaylka",
    "password": "Furaha sirta",
    "loggingIn": "Soo galaya...",
    "createShopAccount": "Samee Akoon Dukaan",
    "shopEmail": "Iimaylka Dukaanka",
    "shopName": "Magaca Dukaanka",
    "shopNamePlaceholder": "Dukaankayga Wanaagsan",
    "ownerFirstName": "Magaca Hore",
    "ownerLastName": "Magaca Dambe",
    "dob": "Taariikhda Dhalashada",
    "country": "Dalka",
    "phone": "Telefoon",
    "creating": "Samaynaya...",
    "createShop": "Samee Dukaan",
    "noAccount": "Akoon dukaan ma lihid?",
    "applyHere": "Halkan codso",
    "hasAccount": "Akoon baad leedahay?",
    "loginHere": "Halkan soo gal",
    "goToUserApp": "Aad App-ka Isticmaalaha",
    "whyDifferent": "Why Moondala is Different",
    "comparison": "vs Traditional Platforms",
    "cta": "Start Selling",
    "feature1": "Social Commerce Feed",
    "feature1Desc": "Your products appear in a social feed that users browse, like, and share.",
    "feature2": "Smart Product Matching",
    "feature2Desc": "Moondala automatically matches your products with interested buyers.",
    "feature3": "Your Own Mall Page",
    "feature3Desc": "Get a dedicated storefront page where customers can browse your full catalog.",
    "feature4": "Mobile App Ready",
    "feature4Desc": "Your shop works seamlessly on Moondala's mobile app.",
    "feature5": "No Monthly Fees",
    "feature5Desc": "Open your shop for free. No monthly subscription, no listing fees.",
    "feature6": "Live in 5 Minutes",
    "feature6Desc": "No approval queue. Sign up, add products, start selling."
  },
  "tr": {
    "heroTitle": "Farklı Sat.",
    "heroSub": "Moondala sıradan bir pazar yeri değil. Müşterilerinizin destekçiniz olduğu sosyal bir pazar yeri.",
    "heroNote": "Aylık ücret yok. Listeleme ücreti yok. Sadece kazandığınızda ödersiniz.",
    "openShopFree": "Mağaza Aç — Ücretsiz",
    "haveAccount": "Hesabım Var",
    "whySellers": "Satıcılar Neden Moondala'yı Seçiyor",
    "whySellersSub": "Gerçekten büyümenize yardımcı olan platformu inşa ettik.",
    "feat1": "Dahili Sosyal Ticaret",
    "feat1Desc": "Mağazanız sosyal akışta yaşıyor.",
    "feat2": "Akıllı Ürün Eşleştirme",
    "feat2Desc": "Ürünler ilgi alanlarına göre gösterilir.",
    "feat3": "Kendi Mall Sayfanız",
    "feat3Desc": "Markalı mağaza vitrini alın.",
    "feat4": "Mobil Öncelikli",
    "feat4Desc": "Müşteriler iOS ve Android uygulamamızdan alışveriş yapar.",
    "feat5": "Aylık Ücret Yok. Asla.",
    "feat5Desc": "Abonelik katmanı yok, gizli maliyet yok.",
    "feat6": "5 Dakikada Kurulum",
    "feat6Desc": "Kaydolun, ürün ekleyin, satışa başlayın.",
    "vsOthers": "Moondala vs. Diğerleri",
    "cmpMonthly": "Aylık Ücret",
    "cmpListing": "Listeleme Ücreti",
    "cmpFree": "Ücretsiz",
    "cmpSocial": "Dahili Sosyal Akış",
    "cmpMobile": "Alıcılar İçin Mobil Uygulama",
    "cmpMatching": "Akıllı Eşleştirme",
    "cmpAlgo": "Algoritma",
    "cmpBasic": "Temel",
    "cmpMall": "Özel Mall/Mağaza",
    "cmpAudience": "Dahili Kitle",
    "stepsTitle": "3 Adımda Satışa Başla",
    "step1": "Mağazanı Oluştur",
    "step1Desc": "Ücretsiz kaydol. İsim seç. 2 dakikada hazır.",
    "step2": "Ürün Ekle",
    "step2Desc": "Fotoğraf yükle, fiyat belirle, açıklama yaz.",
    "step3": "Keşfedil",
    "step3Desc": "Ürünler sosyal akış, mall ve aramada görünür.",
    "ctaTitle": "Mağazan seni bekliyor.",
    "ctaSub": "Ücretsiz başla. Kredi kartı gerekmez. Dakikalar içinde hazır.",
    "ctaBtn": "Şimdi Mağaza Aç",
    "backToOverview": "Genel Bakışa Dön",
    "login": "Giriş",
    "signup": "Kayıt",
    "shopLogin": "Mağaza Girişi",
    "email": "E-posta",
    "password": "Şifre",
    "loggingIn": "Giriş yapılıyor...",
    "createShopAccount": "Mağaza Hesabı Oluştur",
    "shopEmail": "Mağaza E-postası",
    "shopName": "Mağaza Adı",
    "shopNamePlaceholder": "Harika Mağazam",
    "ownerFirstName": "Sahip Adı",
    "ownerLastName": "Sahip Soyadı",
    "dob": "Doğum Tarihi",
    "country": "Ülke",
    "phone": "Telefon",
    "creating": "Oluşturuluyor...",
    "createShop": "Mağaza Oluştur",
    "noAccount": "Mağaza hesabınız yok mu?",
    "applyHere": "Buradan başvur",
    "hasAccount": "Zaten hesabınız var mı?",
    "loginHere": "Buradan giriş yap",
    "goToUserApp": "Kullanıcı Uygulamasına Git",
    "whyDifferent": "Moondala Neden Farklı",
    "comparison": "vs Geleneksel Platformlar",
    "cta": "Satışa Başla",
    "feature1": "Sosyal Ticaret Akışı",
    "feature1Desc": "Sosyal akışta ürünler.",
    "feature2": "Akıllı Eşleştirme",
    "feature2Desc": "Otomatik eşleştirme.",
    "feature3": "Mall Sayfası",
    "feature3Desc": "Özel mağaza sayfası.",
    "feature4": "Mobil Hazır",
    "feature4Desc": "Uygulamada çalışır.",
    "feature5": "Aylık Ücret Yok",
    "feature5Desc": "Ücretsiz aç.",
    "feature6": "5 Dakikada Canlı",
    "feature6Desc": "Onay kuyruğu yok."
  },
  "ur": {
    "heroTitle": "مختلف طریقے سے بیچیں۔",
    "heroSub": "Moondala isn't just another marketplace. It's a social marketplace where your customers become your promoters, and every sale can spark the next one.",
    "heroNote": "کوئی ماہانہ فیس نہیں۔ کوئی لسٹنگ فیس نہیں۔",
    "openShopFree": "دکان کھولیں — مفت",
    "haveAccount": "میرا اکاؤنٹ ہے",
    "whySellers": "Why Sellers Choose Moondala",
    "whySellersSub": "We built what we wished existed — a platform that actually helps you grow, not just hosts your products.",
    "feat1": "Social Commerce Built In",
    "feat1Desc": "Your shop lives inside a social feed. Customers like, comment, share, and buy — all without leaving the app.",
    "feat2": "Smart Product Matching",
    "feat2Desc": "Your products appear in users' feeds and mall based on what they actually care about. No paying for ads.",
    "feat3": "Your Own Mall Page",
    "feat3Desc": "Get a custom, branded storefront — not just a product listing buried in search results.",
    "feat4": "Mobile-First, App-Ready",
    "feat4Desc": "Your customers shop from our iOS & Android app. Push notifications, instant checkout, real mobile experience.",
    "feat5": "No Monthly Fees. Ever.",
    "feat5Desc": "No subscription tiers, no hidden costs. We take a small cut when you sell. That's it.",
    "feat6": "5-Minute Setup",
    "feat6Desc": "Register, add products, start selling. No approval queues, no waiting weeks.",
    "vsOthers": "Moondala vs. Others",
    "cmpMonthly": "Monthly Fee",
    "cmpListing": "Listing Fee",
    "cmpFree": "Free",
    "cmpSocial": "Built-in Social Feed",
    "cmpMobile": "Mobile App for Buyers",
    "cmpMatching": "Smart Product Matching",
    "cmpAlgo": "Algorithm-driven",
    "cmpBasic": "Basic",
    "cmpMall": "Custom Mall / Storefront",
    "cmpAudience": "Built-in Audience",
    "stepsTitle": "3 قدموں میں فروخت شروع کریں",
    "step1": "Create Your Shop",
    "step1Desc": "Sign up free. Pick a name, add your info. Done in 2 minutes.",
    "step2": "Add Products",
    "step2Desc": "Upload photos, set prices, write descriptions. Bulk upload if you have many.",
    "step3": "Get Discovered",
    "step3Desc": "Your products show up in the social feed, mall, and search. Customers come to you.",
    "ctaTitle": "آپ کی دکان انتظار کر رہی ہے۔",
    "ctaSub": "مفت شروع کریں۔ کوئی کریڈٹ کارڈ نہیں۔",
    "ctaBtn": "ابھی دکان کھولیں",
    "backToOverview": "واپس جائزہ پر",
    "login": "لاگ ان",
    "signup": "سائن اپ",
    "shopLogin": "شاپ لاگ ان",
    "email": "ای میل",
    "password": "پاسورڈ",
    "loggingIn": "لاگ ان ہو رہا ہے...",
    "createShopAccount": "شاپ اکاؤنٹ بنائیں",
    "shopEmail": "شاپ ای میل",
    "shopName": "دکان کا نام",
    "shopNamePlaceholder": "میری زبردست دکان",
    "ownerFirstName": "مالک کا نام",
    "ownerLastName": "مالک کا کنیت",
    "dob": "تاریخ پیدائش",
    "country": "ملک",
    "phone": "فون نمبر",
    "creating": "بنا رہے ہیں...",
    "createShop": "دکان بنائیں",
    "noAccount": "شاپ اکاؤنٹ نہیں ہے؟",
    "applyHere": "یہاں درخواست دیں",
    "hasAccount": "پہلے سے اکاؤنٹ ہے؟",
    "loginHere": "یہاں لاگ ان کریں",
    "goToUserApp": "یوزر ایپ پر جائیں",
    "whyDifferent": "Why Moondala is Different",
    "comparison": "vs Traditional Platforms",
    "cta": "Start Selling",
    "feature1": "Social Commerce Feed",
    "feature1Desc": "Your products appear in a social feed that users browse, like, and share.",
    "feature2": "Smart Product Matching",
    "feature2Desc": "Moondala automatically matches your products with interested buyers.",
    "feature3": "Your Own Mall Page",
    "feature3Desc": "Get a dedicated storefront page where customers can browse your full catalog.",
    "feature4": "Mobile App Ready",
    "feature4Desc": "Your shop works seamlessly on Moondala's mobile app.",
    "feature5": "No Monthly Fees",
    "feature5Desc": "Open your shop for free. No monthly subscription, no listing fees.",
    "feature6": "Live in 5 Minutes",
    "feature6Desc": "No approval queue. Sign up, add products, start selling."
  }
};

// Build resources object
const resources = {};
for (const [lang, translations] of Object.entries(shop)) {
  resources[lang] = { translation: { shop: translations } };
}

// Read lang from URL params BEFORE init (in case localStorage wasn't set yet)
const urlParams = new URLSearchParams(window.location.search);
const langFromUrl = urlParams.get("lang");
if (langFromUrl) {
  localStorage.setItem("userLanguage", langFromUrl);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: langFromUrl || undefined, // Force language if from URL
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "userLanguage",
      caches: ["localStorage"],
    },
  });

// RTL support for Arabic & Urdu
i18n.on("languageChanged", (lng) => {
  const rtl = ["ar", "ur"].includes(lng);
  document.documentElement.dir = rtl ? "rtl" : "ltr";
  document.documentElement.lang = lng;
});
const initLang = i18n.language || "en";
document.documentElement.dir = ["ar", "ur"].includes(initLang) ? "rtl" : "ltr";
document.documentElement.lang = initLang;

export default i18n;
